module.exports = __webpack_public_path__ + "static/media/monica.c1a73868.jpg";